import { render, staticRenderFns } from "./SystemDetail.vue?vue&type=template&id=3f87033c&"
import script from "./SystemDetail.vue?vue&type=script&lang=js&"
export * from "./SystemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports